<template>
  <div class="page-wrapper-table">
    <div class="page-wrapper-table-header">
      <el-select
        class="select-primary pagination-select"
        v-model="pagination.perPage"
        :placeholder="$t('COMMON.PER_PAGE')"
      >
        <el-option
          class="select-primary"
          v-for="item in pagination.perPageOptions"
          :key="item"
          :label="item"
          :value="item"
        >
        </el-option>
      </el-select>
      <!--<contact-selector
        v-if="
          !filterContact &&
          $currentUserCan($permissions.PERM_VIEW_ANY_CONTACTS)
        "
        @contactChanged="
          (contactId) => (selectedContact = contactId)
        "
      />-->
      <el-select
        :clearable="true"
        class="select-primary pagination-select"
        v-model="category"
        min-width="220"
        :placeholder="$t('LABELS.COMMUNICATION_TYPE')"
      >
        <el-option
          class="select-primary"
          :label="$t(`COMMON.ALL`)"
          :value="null"
        >
        </el-option>
        <el-option
          v-for="item in CATEGORIES"
          class="select-primary"
          :label="$t(`LABELS.${item}`)"
          :value="item"
          :key="item"
        >
        </el-option>
      </el-select>
      <base-input
        v-model="query"
        type="search"
        prepend-icon="fas fa-search"
        :placeholder="$t('COMMON.SEARCH')"
        clearable
      />
    </div>
    <div class="page-wrapper-table-body">
      <div class="page-wrapper-table-body-inner">
        <el-table
          class="align-items-center table-flush"
          header-row-class-name="thead-light"
          :data="labels"
          @sort-change="sortChange"
        >
          <div class="table-loading" slot="empty" v-if="loading">
            <img src="/img/loading.gif" />
          </div>
          <el-table-column
            :label="$t('LABELS.NAME')"
            prop="name"
            sortable="custom"
            min-width="220"
          >
            <template v-slot="{ row }">
              {{ row.name_translate[language] }}
            </template>
          </el-table-column>
          <el-table-column :label="$t('LABELS.CATEGORY')" min-width="220" sortable="custom">
            <template v-slot="{ row }">
              {{ $t(`LABELS.${row.category}`) }}
            </template>
          </el-table-column>
          <el-table-column
              :label="$t('COMMON.CREATED_AT')"
              prop="created_at"
              sortable="custom"
              min-width="220"
            >
              <template v-slot="{ row }">
                {{ $formatDate(row.created_at) }}
              </template>
            </el-table-column>
          <el-table-column fixed="right" min-width="120">
            <div slot-scope="{ row }" class="table-actions">
              <el-tooltip
                :content="$t('COMMON.VIEW')"
                placement="top"
                v-if="$currentUserCan($permissions.PERM_VIEW_LABELS)"
              >
                <a
                  type="text"
                  @click="viewLabel(row)"
                  class="table-action"
                  data-toggle="tooltip"
                  style="cursor: pointer"
                >
                  <i class="fal fa-expand-alt"></i>
                </a>
              </el-tooltip>

              <el-tooltip
                :content="$t('COMMON.EDIT')"
                placement="top"
                v-if="$currentUserCan($permissions.PERM_EDIT_LABELS)"
              >
                <a
                  type="text"
                  @click="editLabel(row)"
                  class="table-action"
                  data-toggle="tooltip"
                  style="cursor: pointer"
                >
                  <i class="fal fa-edit"></i>
                </a>
              </el-tooltip>

              <el-tooltip
                content="Delete"
                placement="top"
                v-if="$currentUserCan($permissions.PERM_DELETE_LABELS)"
              >
                <a
                  type="text"
                  @click="deleteLabel(row)"
                  class="table-action table-action-delete"
                  data-toggle="tooltip"
                  style="cursor: pointer"
                >
                  <i class="fal fa-trash-alt"></i>
                </a>
              </el-tooltip>
            </div>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div class="page-wrapper-table-footer">
      <p class="card-category">
        {{
          $t("COMMON.DISPLAY_FROM_X_TO_X_OF_X_ENTRIES", {
            from: total ? from + 1 : 0,
            to: to,
            of: total,
          })
        }}

        <span v-if="selectedRows.length">
          &nbsp; &nbsp;
          {{ $t("COMMON.X_LINES_SELECTED", { count: selectedRows.length }) }}
        </span>
      </p>
      <base-pagination
        class="pagination-no-border"
        v-model="pagination.currentPage"
        :per-page="pagination.perPage"
        :total="total"
      />
    </div>
  </div>
</template>
<script>
import _ from "lodash";
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Tooltip,
  Select,
  Option,
  Button,
} from "element-ui";
import swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.css";
import requestErrorMixin from "@/mixins/request-error-mixin";
import { BasePagination } from "@/components";
import { CATEGORIES } from "@/constants/labels";
import { loadLanguageAsync } from "@/plugins/i18n";

export default {
  name: "label-list-table",

  components: {
    BasePagination,
    [Tooltip.name]: Tooltip,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Select.name]: Select,
    [Option.name]: Option,
    [Button.name]: Button,
  },

  mixins: [requestErrorMixin],

  props: {},

  data() {
    return {
      query: null,
      tracking_number:null,
      selectedRows: [],
      sort: "-created_at",
      total: 0,
      CATEGORIES,
      category:null,
      pagination: {
        perPage: 20,
        currentPage: 1,
        perPageOptions: [20, 50, 100, 500],
      },
      labels: [],
      loading: true,
      language: 'fr',
    };
  },

  computed: {
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },

    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
  },

  watch: {
    query: {
      handler: "getListDebounced",
      immediate: true,
    },
    pagination: {
      handler: "getList",
      immediate: false,
      deep: true,
    },
    category: {
      handler: "getListDebounced",
      immediate: true,
    },
  },
  created(){
    this.language = this.$i18n.locale;
  },
  methods: {
    getListDebounced: _.debounce(function () {
      this.getList();
    }, 300),

    async getList() {
      try {
        this.loading = true;
        let params = {
          ...(this.sort ? { sort: this.sort } : {}),
          filter: {
          ...(this.query ? { search: this.query } : {}),
        },
          page: {
            number: this.pagination.currentPage,
            size: this.pagination.perPage,
          },
        };
        if (this.category) {
          params = {
            ...params,
            filter: {
              ...params.filter,
              category: this.category,
            },
          };
        }

        await this.$store.dispatch("labels/list", params);
        this.labels = this.$store.getters["labels/list"];
        this.total = this.$store.getters["labels/listTotal"];
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
      }
    },

    deleteLabel(label) {
      this.$emit("onDeleteLabel", label);
    },

    viewLabel(label) {
      this.$emit("onViewLabel", label);
    },

    editLabel(label) {
      this.$emit("onEditLabel", label);
    },

    sortChange({ prop, order }) {
      if (order === "descending") {
        this.sort = `-${prop}`;
      } else {
        this.sort = `${prop}`;
      }
      this.getList();
    },
  },
};
</script>
